
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CPModal extends Vue {
  @Prop({ default: true })
  public hard!: boolean;

  @Prop({ default: '280px' })
  public minWidth!: string;

  @Prop({ default: '600px' })
  public maxWidth!: string;

  @Prop({ default: false })
  public fullWidth!: boolean;

  public get modal() {
    return this.$store.state.modal;
  }

  @Prop({ default: true })
  public hasClose!: boolean;

  @Prop({ default: false })
  public closeOnBackdrop!: boolean;

  @Prop({ default: false })
  public hasBack!: boolean;

  @Prop({ default: '{fn: openModal, msg: ""}' })
  public closeAction!: any;

  public close(fn: string, msg: any) {
    this.$store.dispatch(fn, msg);
  }

  public closeBackdrop(fn: string, msg: any) {
    if (this.closeOnBackdrop) {
      this.close(fn, msg);
    }
  }
}
